import { useCallback } from 'react';

/**
 * Names a design-system field (e.g. `InputSelectField`) for assistive tech.
 *
 * The component spreads no rest props, so neither `id` nor `aria-label`
 * reaches its trigger, and its own `label` renders as an unassociated span —
 * a visible caption with no accessible name. `ref` is the one prop it does
 * forward, so the name is set through it. Delete this if the design system
 * grows an `aria-label` prop.
 *
 * For filter selects, prefer `commonComponents/filters/SelectFilter`, which
 * applies this for you — it is the only caller left in the app.
 */
export const useAccessibleName = (label) =>
  useCallback(
    (node) => {
      if (node) node.setAttribute('aria-label', label);
    },
    [label],
  );

export default useAccessibleName;
